export default {"src":"/_next/static/media/close-modal.014abb8c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};